import { render } from "./SeeRegisterInformation.vue?vue&type=template&id=05e70130&scoped=true"
import script from "./SeeRegisterInformation.vue?vue&type=script&lang=js"
export * from "./SeeRegisterInformation.vue?vue&type=script&lang=js"

import "./SeeRegisterInformation.vue?vue&type=style&index=0&id=05e70130&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05e70130"

export default script